export default class {
    /* 
        Promiseで整理しずらい時用。
    */
    constructor(
        private stoppers:string[],
        private functions:Function[] = []
    ){
    }

    public runFunction(func:Function){
        if(this.stoppers.length === 0){
            func()
        }else{
            this.functions.push(func);
        }
    }
    public clearStopper(key:string){
        const index = this.stoppers.indexOf(key);
        if (index > -1) {
            this.stoppers.splice(index, 1);
        }
        this.maybeLaunch();        
    }

    private maybeLaunch(){
        if(this.stoppers.length === 0){
            this.functions.forEach((func)=>{
                func()
            })
            this.functions.length = 0;
        }
    }
}
